export const supervisorPanelEvents = Object.freeze({
  QUEUE_MEMBER_ADDED: 'queue_member_added',
  QUEUE_MEMBER_REMOVED: 'queue_member_removed',
  QUEUE_MEMBER_PAUSE: 'queue_member_pause',
  QUEUE_MEMBER_AVAILABLE: 'queue_member_available',
  QUEUE_MEMBER_UNREGISTERED: 'queue_member_unregistered'
});
